// extracted by mini-css-extract-plugin
export default {"checkbox":"ApproveExpenseHeader_checkbox__hAqyT","checkmark":"ApproveExpenseHeader_checkmark__0qiK3"};